<div class="dashboard-coach-container">
  <!-- Header Section -->
  <div class="header-section">
    <span class="current-date">{{ currentDate | date:'fullDate':'':'es-PE' }}</span>
    <h1 class="welcome-title">¡Hola {{ user?.name || 'Marcela' }}!</h1>
    <p class="welcome-subtitle">Bienvenida a tu perfil como mentora</p>
  </div>

  <!-- Agenda Update Banner -->
  <div class="agenda-banner">
    <div class="banner-text-content">
      <h3 class="banner-title">Manten actualizada tu agenda</h3>
      <p class="banner-description">No olvides habilitar tus horarios disponibles en tu agenda.</p>
    </div>
    <button class="btn-enable-hours" (click)="goToAgenda()">Habilitar horarios</button>
  </div>

  
  <!-- Próximas Sesiones Section -->
  <div class="upcoming-sessions-container">
    <div class="section-header">
      <div class="header-content">
        <h2 class="section-title">Próximas sesiones</h2>
        <p class="section-subtitle">Mira la lista de tus próximas sesiones aquí</p>
      </div>
      <button class="btn-view-all" (click)="viewAllSessions()">Ver lista completa</button>
    </div>

    <!-- Table Section -->
    <div class="table-container">
      <table class="sessions-table">
        <thead>
          <tr>
            <th class="sortable" (click)="sortBy('menteeName')">
              Mentoreado
              <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </th>
            <th class="sortable" (click)="sortBy('date')">
              Fecha
              <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </th>
            <th>Hora</th>
            <th>Duración</th>
            <th *ngIf="!isExpertUser()">Hito</th>
            <th>Notas</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let session of paginatedSessions; let i = index" class="session-row">
            <td class="mentee-cell">
              <div class="mentee-info">
                <div class="mentee-avatar">
                  <img [src]="session.menteeAvatar || '/assets/icons/default-avatar.png'" [alt]="session.menteeName" class="avatar-img">
                </div>
                <span class="mentee-name">{{ session.menteeName }}</span>
              </div>
            </td>
            <td class="date-cell">{{ session.date | date:'dd/MM/yyyy' }}</td>
            <td class="time-cell">{{ session.time }}</td>
            <td class="duration-cell">{{ session.duration }} minutos</td>
            <td class="milestone-cell" *ngIf="!isExpertUser()">{{ session.milestone }}</td>
            <td class="notes-cell">
              <button class="notes-btn" (click)="openNotesModal(session)">
                <i class="fas fa-sticky-note"></i>
                {{ session.notes ? 'Ver notas' : 'Agregar notas' }}
              </button>
            </td>
            <td class="action-cell">
              <button class="enter-session-btn" (click)="enterSession(session)">
                Ingresar a sesión
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Usuarios Asignados Section -->
  <div class="assigned-users-container">
    <div class="section-header">
      <div class="header-content">
        <h2 class="section-title">Usuarios asignados</h2>
        <p class="section-subtitle">Mira la lista de tus usuarios asignados aquí</p>
      </div>
      <button class="btn-view-all" (click)="viewAllUsers()">Ver lista completa</button>
    </div>
    <!-- Users Table -->
    <div class="table-container">
      <table class="users-table">
        <thead>
          <tr>
            <th class="sortable" (click)="sortUsersBy('name')">
              Mentoreado
              <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </th>
            <th>Estado</th>
            <th>Etapa actual</th>
            <!-- <th>Tareas pendientes</th> -->
            <th>Próxima cita</th>
            <th>Progreso general</th>
            <th>Ver</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of paginatedUsers; let i = index" class="user-row">
            <td class="user-cell">
              <div class="user-info">
                <div class="user-avatar">
                  <img [src]="user.avatar || '/assets/icons/default-avatar.png'" [alt]="user.name" class="avatar-img">
                </div>
                <span class="user-name">{{ user.name }}</span>
              </div>
            </td>
            <td class="status-cell">
              <div class="status-indicator" [class]="'status-' + user.status">
                <div class="status-dot"></div>
                <span class="status-text">{{ user.status | titlecase }}</span>
              </div>
            </td>
            <td class="stage-cell">{{ user.currentStage }}</td>
            <!-- <td class="tasks-cell">{{ user.pendingTasks }} tarea{{ user.pendingTasks !== 1 ? 's' : '' }} pendiente{{ user.pendingTasks !== 1 ? 's' : '' }}</td> -->
            <td class="appointment-cell">{{ user.nextAppointment }}</td>
            <td class="progress-cell">
              <div class="progress-container">
                <div class="progress-bar-container">
                  <div class="progress-bar" [style.width.%]="user.progress"></div>
                </div>
                <span class="progress-text">{{ user.progress }}%</span>
              </div>
            </td>
            <td class="action-cell">
              <button class="view-button" (click)="viewUser(user)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Modal de cita -->
  @if (showAppointmentModal && selectedAppointment) {
  <div class="modal-overlay" (click)="closeAppointmentModal()">
    <div class="meeting-modal" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeAppointmentModal()">
        <mat-icon>close</mat-icon>
      </button>
      <h2 class="modal-title">Reunión con {{ selectedAppointment.clientName }}</h2>
      <h3 class="meeting-title">Reunión con {{ selectedAppointment.clientName }}</h3>
      <div class="meeting-time">{{ selectedAppointment.time }}</div>
      <div class="meeting-info-section">
        <div class="info-label">ID de reunión:</div>
        <div class="meeting-id">
          <div>{{ getMeetingLink() }}</div>
        </div>
      </div>
      <div class="invitation-message">
        Expertos Phoenix le está invitando a una reunión de Meet programada. Únase a la reunión de Meet con el siguiente link.
      </div>
      <div class="meeting-link-container">
        <div class="meeting-link">
          <mat-icon class="meet-icon">videocam</mat-icon>
          <span>{{ getMeetingLink() }}</span>
        </div>
      </div>
      <div class="modal-actions">
        <button class="btn-join-meeting" (click)="joinMeeting()">
          Unirse a la reunión
        </button>
        <span class="copy-link" (click)="copyMeetingLink()">Copiar enlace</span>
        <button class="btn-send-email" (click)="sendMeetingEmail()">
          <mat-icon>email</mat-icon>
          Enviar por email
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Modal de Alerta -->
  <div class="modal-overlay" *ngIf="showAlertModal" (click)="closeAlertModal()">
    <div class="modal-content alert-modal" (click)="$event.stopPropagation()">
      <!-- Título del modal -->
      <div class="modal-title">
        {{ alertTitle }}
      </div>
      
      <!-- Mensaje del modal -->
      <div class="modal-message">
        {{ alertMessage }}
      </div>
      
      <!-- Botón del modal -->
      <div class="modal-actions">
        <button class="btn-confirm" (click)="closeAlertModal()">
          Aceptar
        </button>
      </div>
    </div>
  </div>

  <!-- Modal para notas de citas -->
  <div class="modal-overlay" *ngIf="showNotesModal" (click)="closeNotesModal()">
    <div class="modal-container notes-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Notas de la sesión</h3>
        <p class="modal-subtitle">Registra observaciones y adjunta documentos para la sesión del {{ selectedAppointment?.date | date: 'dd/MM/yyyy' }} a las {{ (selectedAppointment?.time || '') | timeFormat }}</p>
        <button class="close-modal-btn" (click)="closeNotesModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-content notes-content">
        <div class="notes-editor-section">
          <div class="custom-toolbar">
            <div class="toolbar-group">
              <button class="toolbar-btn" (click)="togglePreview()" [class.active]="showPreview">
                <i class="fas fa-eye"></i>
                Vista previa
              </button>
              <button class="toolbar-btn" (click)="clearQuillEditor()">
                <i class="fas fa-eraser"></i>
                Limpiar
              </button>
            </div>
          </div>

          <div class="editor-content">
            <div
              #quillEditor
              class="quill-editor"
              [style.display]="showPreview ? 'none' : 'block'">
              <div *ngIf="!quillInstance" class="quill-loading">
                <!-- <p>Escribir tus comentarios aquí...</p> -->
              </div>
            </div>

            <div
              *ngIf="showPreview"
              class="preview-content"
              [innerHTML]="appointmentNotes">
            </div>
          </div>
        </div>

        <div class="file-upload-section">
          <div class="file-upload-header">
            <h4 class="file-upload-title">Cargar archivos</h4>
            <button class="upload-file-btn" (click)="triggerFileUpload()">
              <i class="fas fa-cloud-upload-alt"></i>
              Subir archivo
            </button>
          </div>

          <input
            type="file"
            #fileInput
            (change)="onFileSelected($event)"
            multiple
            accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png"
            style="display: none;">

          <div class="files-list" *ngIf="appointmentFiles.length > 0">
            <div class="files-table">
              <div class="files-header">
                <div class="file-name-header">Nombre del archivo</div>
                <div class="file-date-header">Fecha</div>
                <div class="file-actions-header">Acciones</div>
              </div>

              <div class="files-body">
                <div class="file-item" *ngFor="let file of appointmentFiles; let i = index">
                  <div class="file-name">
                    <i class="fas fa-file" [class]="getFileIconClass(file.name)"></i>
                    {{ file.name }}
                  </div>
                  <div class="file-date">{{ file.uploadDate | date: 'dd/MM/yyyy' }}</div>
                  <div class="file-actions">
                    <button class="action-btn view-btn" (click)="viewFile(file)" title="Ver archivo">
                      <i class="fas fa-eye"></i>
                    </button>
                    <button class="action-btn delete-btn" (click)="deleteFile(i)" title="Eliminar archivo">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="no-files" *ngIf="appointmentFiles.length === 0">
            <i class="fas fa-file-upload"></i>
            <p>No hay archivos adjuntos</p>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeNotesModal()">
          Cancelar
        </button>
        <button class="btn-save" (click)="saveAppointmentNotes()" [disabled]="isSavingNotes">
          <i class="fas fa-save" *ngIf="!isSavingNotes"></i>
          <i class="fas fa-spinner fa-spin" *ngIf="isSavingNotes"></i>
          {{ isSavingNotes ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </div>
</div>